import { Component, ViewChild } from '@angular/core';
import { BuyBtnComponent } from 'gung-standard';
import { delay, first, of } from 'rxjs';

@Component({
    selector: 'sjoborg-buy-btn',
    templateUrl: './sjoborg-buy-btn.component.html',
    styleUrls: ['./sjoborg-buy-btn.component.scss'],
    standalone: false
})
export class SjoborgBuyBtnComponent extends BuyBtnComponent {
  @ViewChild('tooltip', { static: false }) tooltip;

  set(value: number) {
    if (value >= this.minimumOrderQuantity && (this.stepAmount === 1 || value % this.stepAmount === 0)) {
      this.cartService.setProductQuantity(this.id, value, this.targetStockId);
    } else if (value >= 0 && value % this.stepAmount !== 0) {
      value += this.stepAmount - (value % this.stepAmount);
      this.cartService.setProductQuantity(this.id, value, this.targetStockId);
      this.showTooltipAdjustedUpQtyToPackageSize();
    } else {
      if (this.checkoutCart) {
        this.gungModalService
          .openConfirmYesNoModal(undefined, this.translationService.instant('REMOVE_PRODUCT') + '?', { size: 'sm' })
          .then(result => {
            if (result) {
              this.cartService.setProductQuantity(this.id, 0, this.targetStockId);
            } else {
              this.cartService.setProductQuantity(this.id, this.previousQty, this.targetStockId);
            }
          });
      } else {
        this.cartService.setProductQuantity(this.id, 0, this.targetStockId);
      }
    }
  }

  showTooltipAdjustedUpQtyToPackageSize(): void {
    this.tooltip.open();
    of(true)
      .pipe(delay(1500), first())
      .subscribe(() => this.tooltip.close());
  }
}
